import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { AnyAction, Middleware } from 'redux';
import { signOutUser } from '@actions';
import { RootState } from '@reducers';
import { TOKEN_EXPIRED_WARNING } from '@rootCommon/constants/messages';
import Message from '@rootCommon/services';

dayjs.extend(isSameOrAfter);

// eslint-disable-next-line consistent-return, @typescript-eslint/ban-types
export const checkTokenExpirationMiddleware: Middleware<{}, RootState> = (store) => (next) => (action: AnyAction) => {
  const result = next(action);
  const state = store.getState();
  const { dispatch } = store;

  const isLoggedIn = state.auth?.data?.loggedIn;

  const expirationDate = state.auth?.data?.expirationDate;
  const isExpired = expirationDate ? dayjs().isSameOrAfter(expirationDate) : true;

  const isError = result?.payload instanceof Error;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const statusCode = isError && result?.payload?.response?.status;
  const isNotAuthorized = isError && statusCode === 401;

  if (isLoggedIn && (isExpired || isNotAuthorized)) {
    dispatch(signOutUser());
    Message.warn(TOKEN_EXPIRED_WARNING);
  } else {
    return result;
  }
};

export default checkTokenExpirationMiddleware;
